import React from 'react'
import { Link } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import PlayerReportGashLogForm from '../../../components/admin/playerReport/gashLog/PlayerReportGashLogForm'
import PlayerReportGashLogTable from '../../../components/admin/playerReport/gashLog/PlayerReportGashLogTable'
import { Path } from '../../../components/admin/route/route'
import { useCommonStyles } from '../../../utils/admin/StyleHook'
import useT from '../../../i18ns/admin/useT'
import { useChecker } from '../../../utils/admin/AdminRouteHook'
import { PermissionType } from '@golden/gdk-admin'

const PlayerReportGashLogPage: React.FC = () => {
  const commonClasses = useCommonStyles()
  const { t } = useT()
  const addable = useChecker([PermissionType.PLAYER_REPORT_GASH_TRANSACTION_RECORD_EDIT])
  return (
    <Box paddingY={5}>
      {
        addable && (
          <Box paddingX={5} display='flex' justifyContent='flex-end'>
            <Button
              component={Link}
              to={Path.PLAYER_REPORT_GASH_LOG_ADD}
              className={commonClasses.purpleGradualButton}
              classes={{ disabled: commonClasses.disabledButton }}
            >
              {t('common.create')}
            </Button>
          </Box>
        )
      }
      <Box paddingX={5}  paddingTop={3}>
        <PlayerReportGashLogForm />
      </Box>
      <PlayerReportGashLogTable />
    </Box>
  )
}

export default React.memo(PlayerReportGashLogPage)
